export default "__VITE_ASSET__CFck7Kaw__"